import { createContext, useContext, useState } from "react";

const Ctx = createContext({
  selectedPropertyId: "",
  setSelectedPropertyId: () => {},
  selectedRoomId: "",
  setSelectedRoomId: () => {},
});

export function PropertyFilterProvider({ children }) {
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [selectedRoomId, setSelectedRoomId]         = useState("");

  const setProperty = (id) => {
    setSelectedPropertyId(id);
    setSelectedRoomId("");   // clear room whenever property changes
  };

  return (
    <Ctx.Provider value={{
      selectedPropertyId,
      setSelectedPropertyId: setProperty,
      selectedRoomId,
      setSelectedRoomId,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export function usePropertyFilter() {
  return useContext(Ctx);
}
